import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateViolationsConfiguration } from './updateViolationsConfiguration'
import { ViolationConfigurationPayload } from './types'

import { QUERY_KEY_SETTINGS_VIOLATION } from '@/lib/api/constants'
import { toast } from '@/lib/toasts/api'

export function useMutationViolationsConfiguration(companyId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: ViolationConfigurationPayload) => {
    //   if (COMPANY_API_SETTINGS_MOCKED) {
    //     return { success: true, data: { message: 'Success' } }
    //   }
      const { data } = await updateViolationsConfiguration({
        companyId,
        payload,
      })
      return data
    },

    onError: (error) => {
      console.error('Error useMutationViolationsConfiguration:', error)
      toast.error({
        text: 'Nie udało się zapisać danych.',
      })
    },

    onSuccess: (responseData, payload, ctx) => {
      const isSuccess = true // responseData.success
      if (isSuccess) {
        // queryClient.setQueryData([QUERY_KEY_SETTINGS_VIOLATION, companyId], payload)
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SETTINGS_VIOLATION, companyId] })
        toast.success({
          text: 'Configuration saved successfully.',
        })
      } else {
        toast.error({
          text: `❌ Failed to save configuration.\nDetails: ${responseData?.data?.message || 'No additional details available.'}`,
        })
      }
    },
  })
}
